/**************************************************
 * Nombre:       Etiquetas_Relacionadas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Chip, Grid} from "@mui/material";

const Etiquetas_Relacionadas = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={1}
        >

            {item && item.categorias && item.categorias.map((item, index) => (
                <Chip label={item} size={'medium'} variant={'outlined'} color={'primary'} key={index}/>
            ))}

        </Grid>
    )

}
export default Etiquetas_Relacionadas

const items = ['uno', 'dos', 'tres']